import Proxy from './Proxy';

class TxProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/tx', parameters);
  }

  get_tx_info(data) {
    this.set_data(data);
    return this.submit('post', `${this.endpoint}/tx`);
  }

  charts(currency) {
    return this.submit('get', `/charts?name=${currency}`);
  }

  get_volume(currency) {
    return this.submit('get', `/total?name=${currency}`);
  }
}

export default TxProxy;
